import { Form, Input } from "decorator-form";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import Course from "../../entities/Course";
import * as filterFragments from "../../fragments/filterFragments";
import * as generalFragments from "../../fragments/generalFragments";
import * as actionFragments from "../fragments/cartActionFragments";
import * as displayFragments from "../fragments/cartDisplayFragments";
import * as parentContainerFragments from "../fragments/cartParentContainerFragments";
import * as itemContainerFragments from "../fragments/cartItemContainerFragments";

const CourseSelect = EntitySelect.registered({
    entity: Course,
    type: 'one',
    getText: 'title'
}, 'string');

const cartItemsLayout = FragmentProvider.getLayoutInput({ ...displayFragments, ...actionFragments });
const generalFragmentsInput = FragmentProvider.getLayoutInput({ ...generalFragments, ...filterFragments });
const containerFragmentsInput = FragmentProvider.getInput(parentContainerFragments);
const itemFragmentInput = FragmentProvider.getInput(itemContainerFragments);

@Form({ title: "Cart Items" })
export default class CartItemsListPanelConfig {

    // @Input({ type: generalFragmentsInput, title: "Main Layout" })
    // public mainLayout: ILayout<IFragmentLayoutConfig>;

    @Input({ type: cartItemsLayout, title: "Cart Items Layout" })
    public cartItemsLayout: ILayout<IFragmentLayoutConfig>;

    @Input({ type: containerFragmentsInput, title: "Container Type" })
    public containerFragment: string;

    @Input({ type: itemFragmentInput, title: "Item Wrapper Type" })
    public itemFragment: string;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/config/CartItemsListPanelConfig.ts